'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "sms-btn",
      attrs: {
        "disabled": _vm.disabled
      },
      domProps: {
        "textContent": _vm._s(_vm.text)
      }
    });
  },
  staticRenderFns: [],
  name: 'sms-button',
  props: {
    status: String
  },
  data: function data() {
    return {
      timer: 0,
      count: 0,
      text: '获取验证码',
      disabled: false
    };
  },
  mounted: function mounted() {
    this.watchStatus();
  },
  methods: {
    watchStatus: function watchStatus() {
      this.reset();
      this.disable();
    },
    disable: function disable() {
      if (!this.disabled && this.status === 'disable') {
        this.disabled = true;
        this.count = 60;
        this.clock();
      }
    },
    clock: function clock() {
      if (--this.count) {
        this.text = "".concat(this.count, " s");
        this.timer = window.setTimeout(this.clock, 1000);
      } else {
        this.$emit('reset');
      }
    },
    reset: function reset() {
      if (this.disabled && this.status === 'enable') {
        clearTimeout(this.timer);
        this.disabled = false;
        this.text = '获取验证码';
      }
    }
  },
  watch: {
    status: function status() {
      this.watchStatus();
    }
  }
});

exports.default = index;
